import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { WellnessSuccessAvatar } from "..";

interface IPlanConfirmationCardProps {
  petName: string;
  petImage: string;
  planName: string;
  onDismiss: () => void;
}

const WoohooCard = ({ petName, planName, onDismiss }: IPlanConfirmationCardProps) => {
  return (
    <Box
      className="relative flex items-center gap-3 p-4 rounded-xl"
      sx={{
        bgcolor: "common.white",
        boxShadow: "2px 2px 18px 0px rgba(55, 54, 23, 0.1)",
      }}
    >
      <WellnessSuccessAvatar image='/assets/icons/care-items.svg' name={petName} showWellnessTag={false} />
      <Box className="flex flex-col gap-1 flex-1 min-w-0">
        <Typography
          sx={{
            fontFamily: "geograph-medium, sans-serif",
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "20px",
            color: "black.main",
          }}
        >
          Woohoo! <span className="capitalize">{petName}</span> is on the {planName}!
        </Typography>
        <Typography
          sx={{
            fontFamily: "geograph-regular, sans-serif",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "18px",
            color: "black.main",
          }}
        >
          We&apos;ve sent you a confirmation email.
        </Typography>
      </Box>
      <IconButton
        onClick={onDismiss}
        aria-label="Dismiss"
        className="!absolute !top-2 !right-2"
        size="small"
      >
        <CloseIcon sx={{ fontSize: 18, color: "black.main" }} />
      </IconButton>
    </Box>
  );
};

export default WoohooCard;
